import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const CHANGE_STATUS_ENDPOINT = (id) => `/api/v1/complaints/${id}`;

const rejectRequest = (error, thunkApi) =>
  thunkApi.rejectWithValue({
    status: error?.response?.status ?? error?.status,
    message:
      error?.response?.data?.message ??
      error?.response?.data?.error ??
      error?.message ??
      'Something went wrong',
  });

function toId(value) {
  if (value == null || value === '') return undefined;
  const numeric = Number(value);
  return Number.isNaN(numeric) ? undefined : numeric;
}

export const changeComplaintStatus = createAsyncThunk(
  'changeStatus/update',
  async (
    { id, statusId, currentStepId, assignedToUserId, onSuccess, onFail },
    thunkApi,
  ) => {
    try {
      const data = {};
      const nextStatusId = toId(statusId);
      const nextStepId = toId(currentStepId);
      const nextAssignedToUserId = toId(assignedToUserId);

      if (nextStatusId != null) data.statusId = nextStatusId;
      if (nextStepId != null) data.currentStepId = nextStepId;
      if (nextAssignedToUserId != null) data.assignedToUserId = nextAssignedToUserId;

      const response = await api.patch(CHANGE_STATUS_ENDPOINT(id), data, {
        signal: thunkApi.signal,
      });
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess(response.data);
      }
      return response.data;
    } catch (error) {
      if (onFail && typeof onFail === 'function') {
        onFail(error);
      }
      return rejectRequest(error, thunkApi);
    }
  },
);
